'use strict';


// Run all TTAM.ready queued callbacks
(function() {
    _.forEach(window.TTAM._callbacks, function(callback) {
        callback();
    });
})();

// Base initializers
// TODO: replace and/or remove the related files once the functionality
// has been converted to use react
(function() {
    TTAM.cart();
    TTAM.chrome();
    TTAM.dropdownMenu.init();
    TTAM.consoleMessages();
    TTAM.drawers();
    TTAM.veil();
    TTAM.fonts();
    TTAM.lazyLoad();
    TTAM.modals();
    Tipped.create('.js-tooltip');
})();

//# sourceMappingURL=project.js.map